import { useEffect, useState } from 'react';
import { fetchAddressSuggestions } from '@/api/addressSuggestions';
const DEBOUNCE_MS = 350;
export function useAddressSuggestions(query, enabled) {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (!enabled) {
            setSuggestions([]);
            return;
        }
        const trimmed = query.trim();
        if (trimmed.length < 3) {
            setSuggestions([]);
            return;
        }
        let cancelled = false;
        const timer = window.setTimeout(async () => {
            setLoading(true);
            try {
                const items = await fetchAddressSuggestions(trimmed, 5);
                if (!cancelled)
                    setSuggestions(items);
            }
            catch {
                if (!cancelled)
                    setSuggestions([]);
            }
            finally {
                if (!cancelled)
                    setLoading(false);
            }
        }, DEBOUNCE_MS);
        return () => {
            cancelled = true;
            window.clearTimeout(timer);
        };
    }, [query, enabled]);
    return { suggestions, loading };
}
